import { createContext } from 'react';
import type { UserManagementType } from './UserManagement.type.ts';

export const UserManagementContext = createContext<UserManagementType | null>(null);
